import React from 'react';
import Icon from '../../../components/AppIcon';

const WhySleeveSection = () => {
  const reasons = [
    {
      id: 1,
      icon: "Unlock",
      title: "No Vendor Lock-In",
      description: "Hardware-agnostic architecture works with any AI model, any cloud provider, any edge device. Sleeve orchestrates—it doesn't constrain your technology choices."
    },
    {
      id: 2,
      icon: "Wrench",
      title: "Works with Legacy Infrastructure",
      description: "Protocol adapters for Modbus, OPC UA, CAN, MQTT, DDS. Integrate decades-old systems without replacement or modification."
    },
    {
      id: 3,
      icon: "Wifi",
      title: "Built for Unreliable Networks",
      description: "Tolerates network partitions, node failures, and degraded connectivity. Agents operate autonomously with eventual consistency guarantees."
    },
    {
      id: 4,
      icon: "Code",
      title: "Developer-First Platform",
      description: "Policy-as-code, CI/CD integration, simulation environments, and visual debugging. Infrastructure-as-code for reproducible deployments."
    },
    {
      id: 5,
      icon: "Lock",
      title: "Enterprise Security & Compliance",
      description: "On-premises or private cloud deployment. SOC 2 Type II certified. RBAC, audit logs, and compliance reporting built-in."
    },
    {
      id: 6,
      icon: "TrendingUp",
      title: "Scale from Prototype to Production",
      description: "Same orchestration layer in dev, staging, and production. Identical agent behavior from laptop simulations to fleet deployments."
    }
  ];

  return (
    <section className="py-24 px-4 md:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16 lg:mb-20">
          <h2 className="text-2xl font-bold text-foreground mb-3 md:mb-4 lg:mb-5">
            Why Engineering Teams Choose Sleeve
          </h2>
          <p className="text-sm md:text-base lg:text-lg text-muted-foreground max-w-2xl mx-auto">
            Built for the realities of industrial-scale distributed systems
          </p>
        </div>

        {/* Reasons List */}
        <div className="space-y-6 md:space-y-8 lg:space-y-10">
          {reasons?.map((reason) => (
            <div
              key={reason?.id}
              className="flex items-start gap-4 p-6 md:p-7 lg:p-8 bg-card border border-border rounded-lg hover:border-primary/50 transition-all duration-300"
            >
              {/* Icon */}
              <div className="w-10 h-10 rounded-lg bg-accent/10 flex items-center justify-center flex-shrink-0">
                <Icon name={reason?.icon} size={20} color="var(--color-primary)" />
              </div>

              {/* Content */}
              <div className="flex flex-col gap-2 flex-1">
                <h3 className="text-lg md:text-xl font-semibold text-foreground">
                  {reason?.title}
                </h3>
                <p className="text-xs md:text-sm lg:text-base text-muted-foreground leading-relaxed">
                  {reason?.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhySleeveSection;